import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button, Input } from "semantic-ui-react";
import { push } from 'react-router-redux';
import {gunaldiStyles} from "../../SharedComponents/GunaldiDesignStyles";
import API_Backend_Root from "../../Constants/API_Backend_Root";

class APICustomIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createNewAPI: false,
            error: null,
            customApis: [],
            loading: false,
            showCreateForm: false,
            apiName: '',
            apiDescription: '',
            accessKey: null,
            secretKey: null
        }
    }

    componentDidMount() {
        this.fetchAccountKeys();
    }

    fetchAccountKeys = async () => {
        try {
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "fetch-account-keys/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: userEmail
                })
            });

            if (response.ok) {
                const data = await response.json();
                this.setState({
                    accessKey: data.access_key,
                    secretKey: data.secret_key
                }, () => {
                    // After setting the keys, fetch the custom APIs
                    this.fetchCustomAPIs();
                });
            } else {
                const errorData = await response.json();
                this.setState({ 
                    error: errorData.error || "Failed to fetch account keys",
                    loading: false 
                });
            }
        } catch (error) {
            console.error('Error fetching account keys:', error);
            this.setState({ 
                error: "Network error while fetching account keys",
                loading: false 
            });
        }
    }

    fetchCustomAPIs = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    loading: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "custom/list/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch custom APIs: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            this.setState({ 
                customApis: data.custom_apis || [],
                loading: false 
            });
            
        } catch (error) {
            console.error('Error fetching custom APIs:', error);
            this.setState({ 
                error: error.message || "Failed to fetch custom APIs",
                loading: false 
            });
        }
    }

    handleCreateNewAPI = () => {
        this.setState({ showCreateForm: true });
    }

    handleCancelCreate = () => {
        this.setState({ 
            showCreateForm: false, 
            apiName: '', 
            apiDescription: '',
            error: null 
        });
    }

    handleApiNameChange = (e) => {
        this.setState({ apiName: e.target.value });
    }

    handleApiDescriptionChange = (e) => {
        this.setState({ apiDescription: e.target.value });
    }

    handleSubmitCreate = async () => {
        try {
            this.setState({ createNewAPI: true, error: null });
            
            const { accessKey, secretKey } = this.state;
            
            if (!accessKey || !secretKey) {
                this.setState({ 
                    error: "Account keys not available. Please refresh the page.",
                    createNewAPI: false 
                });
                return;
            }

            const response = await fetch(API_Backend_Root + "custom/create/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                    'accessKey': accessKey,
                    'secretKey': secretKey
                },
                body: JSON.stringify({
                    api_name: this.state.apiName,
                    api_description: this.state.apiDescription
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to create custom API: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            console.log("Custom API created successfully:", data.custom_api);
            this.setState({ 
                createNewAPI: false,
                showCreateForm: false,
                apiName: '',
                apiDescription: ''
            });
            
            // Refresh the list of custom APIs
            this.fetchCustomAPIs();
            
        } catch (error) {
            console.error('Error creating custom API:', error);
            this.setState({ 
                error: error.message || "Failed to create custom API",
                createNewAPI: false 
            });
        }
    }

    render() {
        return (
            <div style={{ padding: "20px" }}>
                <div style={{
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    backgroundColor: 'white',
                    minHeight: '400px',
                    padding: '20px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    {/* Header and Button on same line */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '20px'
                    }}>
                        <h2 style={{ margin: 0 }}>Custom APIs</h2>
                        {!this.state.showCreateForm ? (
                            <Button 
                                content="Create new custom API"
                                icon="plus"
                                style={gunaldiStyles.btnGreen}
                                onClick={this.handleCreateNewAPI}
                            />
                        ) : (
                            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <Input
                                    placeholder="API Name"
                                    value={this.state.apiName}
                                    onChange={this.handleApiNameChange}
                                    style={{ minWidth: '150px' }}
                                />
                                <Input
                                    placeholder="API Description"
                                    value={this.state.apiDescription}
                                    onChange={this.handleApiDescriptionChange}
                                    style={{ minWidth: '200px' }}
                                />
                                <Button 
                                    content="Create"
                                    icon="check"
                                    style={gunaldiStyles.btnGreen}
                                    loading={this.state.createNewAPI}
                                    onClick={this.handleSubmitCreate}
                                />
                                <Button 
                                    content="Cancel"
                                    icon="cancel"
                                    style={{ backgroundColor: '#6c757d', color: 'white' }}
                                    onClick={this.handleCancelCreate}
                                />
                            </div>
                        )}
                    </div>
                    
                    {/* Error message */}
                    {this.state.error && (
                        <div style={{
                            backgroundColor: '#ffebee',
                            color: '#c62828',
                            padding: '12px',
                            borderRadius: '4px',
                            marginBottom: '20px'
                        }}>
                            Error: {this.state.error}
                        </div>
                    )}

                    {/* Loading state */}
                    {this.state.loading ? (
                        <div style={{ textAlign: 'center', padding: '40px' }}>
                            <div>Loading custom APIs...</div>
                        </div>
                    ) : this.state.customApis.length === 0 ? (
                        <div style={{ 
                            textAlign: 'center', 
                            padding: '40px', 
                            color: '#666',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '6px'
                        }}>
                            No custom APIs found. Create your first one!
                        </div>
                    ) : (
                        /* Custom APIs Table */
                        <div style={{
                            border: '1px solid #ddd',
                            borderRadius: '6px',
                            overflow: 'hidden'
                        }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ backgroundColor: '#f8f9fa' }}>
                                        <th style={{ 
                                            padding: '12px 16px', 
                                            textAlign: 'left', 
                                            borderBottom: '1px solid #ddd',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            API Name
                                        </th>
                                        <th style={{ 
                                            padding: '12px 16px', 
                                            textAlign: 'left', 
                                            borderBottom: '1px solid #ddd',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            API ID
                                        </th>
                                        <th style={{ 
                                            padding: '12px 16px', 
                                            textAlign: 'left', 
                                            borderBottom: '1px solid #ddd',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            Description
                                        </th>
                                        <th style={{ 
                                            padding: '12px 16px', 
                                            textAlign: 'left', 
                                            borderBottom: '1px solid #ddd',
                                            fontWeight: '600',
                                            color: '#333'
                                        }}>
                                            Created
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.customApis.map((api, index) => (
                                        <tr 
                                            key={api.id} 
                                            style={{ 
                                                borderBottom: '1px solid #eee',
                                                backgroundColor: index % 2 === 0 ? 'white' : '#fafafa',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => this.props.navigateTo(`/custom/${api.customapi_hash}`)}  // Add this
                                        >
                                            <td style={{ 
                                                padding: '12px 16px',
                                                fontWeight: '500',
                                                color: '#333'
                                            }}>
                                                {api.api_name || 'Untitled API'}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 16px',
                                                fontFamily: 'monospace',
                                                fontSize: '12px',
                                                color: '#666'
                                            }}>
                                                {api.customapi_hash}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 16px',
                                                color: '#666'
                                            }}>
                                                {api.api_description || 'No description'}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 16px',
                                                color: '#666',
                                                fontSize: '14px'
                                            }}>
                                                {new Date(api.created_dt).toLocaleDateString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    // Add any state props you need
})

const mapActionsToProps = {
    navigateTo: push
}

export default connect(mapStateToProps, mapActionsToProps)(APICustomIndex)